import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges, ViewEncapsulation } from '@angular/core';

/**
 * libs
 */
import { MarkerClustererOptions } from '@googlemaps/markerclustererplus';

/**
 * enums
 */
import { COMPARE_TYPE } from 'src/app/core/enums/ads/compare-types';
import { BLOCK_DIRECTION } from 'src/app/core/enums/global/block-direction';
/**
 * interfaces
 */
import { IRega } from 'src/app/core/interfaces/ads/rega';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * services
 */
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';

@Component({
  selector: 'app-advertisement-map-details',
  templateUrl: './advertisement-map-details.component.html',
  styleUrls: ['./advertisement-map-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementMapDetailsComponent implements OnInit, OnChanges {

  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'advertisementData', required: true }) public AdvertisementData: IAdvertisementResponse = null;   

  /**
   * regaData
   * @description rega Data
   */
  @Input({ alias: 'regaAdvertisementData', required: true }) public RegaAdvertisementData: IRega = null;    

  /************  Fields  ************/
  /**
   * 
   */
  public Map: google.maps.Map;

  /**
   * MapOption
   * @description for view Advertisement location or places around Advertisement
   */
  public MapOption: number = 0;

  /**
   * IAdvertisementResponse
   * @description to get data to map marker
   */
  public AdvertisementCardModel: IAdvertisementResponse = null;

  /**
   * @description google map place value
   */
  public PlaceType: string = ''

  /**
   * @description google map places result
   */
  public Places: any[] = []

  /**
   * PlacesType
   * @description list of google map place
   */
  public PlacesType: any[] = []

  /**
   * 
   */
  public CompareType: string = ''

  /**
   * 
   */
  public listOfAdsCompare: any[] = []

  /**
   * 
   */
  public listOfCompareType: any[] = []  


  /**
   * IsLoading
   * @description loading Places 
   */
  public IsLoading: boolean = false

  /**
   * 
   */
  public googleMapsOptions: google.maps.MapOptions = {
    zoom: 14,
    scrollwheel: false,
    mapTypeControl: true,
    fullscreenControl: true
  }

  /**
   * 
   */
  markerOptions: google.maps.MarkerOptions = {
    optimized: true,
    crossOnDrag: false,
    icon: {
      url: '/assets/img/transparent.png',
      size: isPlatformBrowser(this.platformId) ? new google.maps.Size(1, 1) : null,
    },    
  }

  /**
   * 
   */
  markerClusterStyle: MarkerClustererOptions = {
    minimumClusterSize: 2,
    zoomOnClick: false,
    clusterClass: 'Marker_cluster',
    averageCenter: true,
    styles: [{
      textColor: 'white',
      textSize: 10,
      fontStyle: 'bolder',
      width: 43,
      height: 43
    }]
  };  

  /************  Accessors  ************/
  /**
   * @description get lat & lng from rega if it not null, then get lat & lng from Ad Owner
   * @returns Object: { lat, lng }
   */
  public get Coords() {

    // ES6 Destruction with Nested & Rename
    const { 
      location: { 
        coordinates: [ lng, lat ] = []
      }
    } = this.AdvertisementData;
    const { 
      location: { 
        latitude,
        longitude 
      } = { latitude: null, longitude: null } 
    } = this.RegaAdvertisementData || {};
    
    /**
     * Rega Coords
     */
    if (latitude != null || longitude != null) return { lat: +latitude, lng: +longitude };

    /**
     * Ad Owner Coords
     */
    return { lat, lng };

  }

  /**
   * 
   */
  public get BLOCK_DIRECTION(): typeof BLOCK_DIRECTION {
    return BLOCK_DIRECTION
  }

  /**
   *
   */
  constructor(
    private _cdr: ChangeDetectorRef,
    private _adOperation: AdOperationService,
    @Inject(PLATFORM_ID) private platformId: any,    
  ) {}

  /************  LifeCycleHooks  ************/
  /**
   * 
   * @param changes 
   */
  ngOnChanges(changes: SimpleChanges): void {

    // ES6 Destruction
    const { AdvertisementData : { currentValue, previousValue, firstChange }} = changes;

    /**
     * 
     */
    if (firstChange || currentValue?.id != previousValue?.id) this.MapOption = 0;


  }  

  public ngOnInit(): void {
    
    // set props
    this.listOfCompareType = [
      { name: 'الكل', type: COMPARE_TYPE.all },
      { name: 'سعر أقل', type: COMPARE_TYPE.down },
      { name: 'سعر أعلى', type: COMPARE_TYPE.up }
    ];

    this.PlacesType = [
      { name: 'المستشفيات', type: 'hospital' },
      { name: 'المساجد', type: 'mosque' },
      { name: 'المدارس', type: 'school' },
      { name: 'المحلات التجارية', type: 'store' },
      { name: 'محطة قطار', type: 'train_station' },
      { name: 'محطة باصات', type: 'bus_station' },
      { name: 'مطاعم', type: 'restaurant' },
    ];     

  }

  /************  Methods  ************/
  /**
   * 
   */
  setCenterMap() {

    /**
     * 
     */
    this.Map?.panTo(this.Coords);

  } 
  
  /**
   * 
   * @param type 
   */
  public GetPlacesByType(type: string) {
    
    // ES6 destructuring
    const { lat, lng } = this.Coords

    if (lng && lat) {
  
      if (type != this.PlaceType) {

        // show loader
        this.IsLoading = true

        // set place_type to mark in tab is has select
        this.PlaceType = type        

        let querys = {
            type,
            radius: 4000,
            openNow: undefined,
            location: {lat, lng},
        };


        let callback = (results: any[], status: string) => {

          // console.log(results)
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.IsLoading = false
            this.Places = JSON.parse(JSON.stringify(results));
          }
          else {
            this.IsLoading = false;
            this.Places = []
          }

          // 
          this._cdr.detectChanges()

        }

        //
        if (this.Map) {
            
          const service = new google.maps.places.PlacesService(this.Map);
          service.nearbySearch(querys, callback);

        }        

      }

    }

  }
  
  /**
   * 
   * @param advertisement 
   */
  public GetAdvertisementData(advertisement: IAdvertisementResponse) {
    
    let 
        map = document.getElementById('Agm_map'),
        customModel = document.getElementById('custom_model');

    map?.firstElementChild?.firstElementChild?.appendChild(customModel as HTMLElement)
    
    //
    this.AdvertisementCardModel = advertisement

    //
    this._adOperation.viewAds(advertisement);

  }  

}
